/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { OPTIONALLY_INCLUDE_INCLUSION_TYPE } from '../../../constants'
import { useI18n } from '../../../hooks'
import { useAppSelector } from '../../../store'
import { ProductVariant, ProductWithVariants } from '../../../types'
import { findProductByVariant, getAmountWithCurrency } from '../../../utils'
import Image from '../../atoms/images/image'

export type OptionalProduct = ProductWithVariants & { productVariantId: string }

const OptionalDependencies: FC<{ variant: ProductVariant; history?: any }> = ({ variant, history }) => {
  const { t } = useI18n()
  const { settings } = useAppSelector((state) => state.appConfigReducer)
  const { products } = useAppSelector((state) => state.productReducer)
  const { cartItems } = useAppSelector((state) => state.cartReducer)

  const dependenciesAvailable =
    variant &&
    !!variant.dependencies?.length &&
    variant.dependencies[0].inclusionType === OPTIONALLY_INCLUDE_INCLUSION_TYPE &&
    !!variant.dependencies[0].productVariantIds.length

  const [optionalProducts, setOptionalProducts] = useState<OptionalProduct[]>([])
  useEffect(() => {
    if (dependenciesAvailable) {
      const [dependencies] = variant.dependencies
      const cartItemsProductVariantIds = cartItems.map((c) => c.cartItemApiInfo.productVariantId)
      const foundVariants = dependencies.productVariantIds.filter((v) => !cartItemsProductVariantIds.includes(v))

      const foundProducts = foundVariants.map((v) => ({
        ...findProductByVariant(products, v),
        ...{ productVariantId: v },
      })) as OptionalProduct[]
      setOptionalProducts(foundProducts)
    }
  }, [variant, products, dependenciesAvailable, cartItems])

  return (
    <>
      {dependenciesAvailable && !!optionalProducts.length && (
        <>
          <h3 className="heavy">{t('OptionalDependency_include')}</h3>
          <div className="cart-item-optional-cards-wrapper">
            {optionalProducts.map((p, i) => (
              <div key={variant.productVariantId + p?.productId + i} className="optional-cart-item-card search-result-column">
                <Link
                  to={{
                    pathname: `/products/${p?.productId}`,
                    search: `productVariant=${p?.productVariantId}`,
                    state: {
                      path: history.location.pathname,
                      search: history.location.search,
                      productName: p?.name,
                      locationPath: `/products/${p?.productId}/?productVariant=${p?.productVariantId}`,
                    },
                  }}
                  title={p?.name || 'Product Description Card'}
                  style={{ textDecoration: 'none' }}
                  className="search-result-link-column"
                >
                  <Image
                    className="cart-item-optional-image"
                    sizeType="card"
                    src={p?.mediaUrls && !!p?.mediaUrls.length ? (p?.mediaUrls[0].url as string) : ''}
                    alt={p?.mediaUrls && !!p?.mediaUrls.length ? (p?.mediaUrls[0].alt as string) : ''}
                    size={{ width: 50, height: 50 }}
                  />
                  <div className="search-result-card-content">
                    <div className="product-name-header">{p?.name}</div>
                    <div className="product-price-container">
                      <div className="low-price-container">
                        <div className="product-start-price-label">{t('Common_startingFrom')}</div>
                        <div className="product-low-price heavy">
                          {p?.asLowAs?.price
                            ? `${getAmountWithCurrency(settings.locale.language, p.asLowAs.currencyType, p.asLowAs.price)}`
                            : 'FREE'}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default OptionalDependencies
